import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, Typography, TextField ,InputAdornment ,Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { DropdownTableInput } from '_components';
import { CustomerDetails } from 'container/admin';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SearchIcon from '@mui/icons-material/Search';
import { customerAction, alertActions, marketerAction } from '_store';
import {useCheckRole } from '_utils/role-access';
import { ERR_MSG } from 'constants/labels';

const Customer = () => {
    const header = "Customer Details";
    const [searchInput, setSearchInput] = useState("");
    const [data,setData] = useState([]);
    const [actualData,setActualData] = useState({});
    const [marketerlist,setMarketerList] = useState([]);
    const [marketerGroupList, setmarketerGroupList] = useState([]);
    const [marketerGroup, setMarketerGroup] = useState([]);
    const [isDataChanged, setIsDataChanged] = useState(false);
    //Check role
      const hasUpdateAccountMarketerAssociationAccess =useCheckRole(4,"UpdateAccountMarketerAssociation")
    const dispatch = useDispatch();
    const marketer = (marketerlist?.map(x => ({
        label: x.ShortName,
        value: x.CompanyID
    })) || []).sort((a, b) => a.label.localeCompare(b.label));

    const marketerGroups = marketerGroup?.map(x => ({
        label: x.Name,
        value: x.AllocationGroupID
    }));

    const handleSearch = async () => {
      setIsDataChanged(false);
      dispatch(alertActions.clear());
      try {
        const result = await dispatch(
          customerAction.getCustomerDetails(searchInput),
        ).unwrap();
        const customerDetails = result;
        if (customerDetails?.Data) {
          setData([customerDetails?.Data]);
          setActualData(customerDetails?.Data);
          setMarketerList(customerDetails?.Data?.Marketer);
          const marketerId = customerDetails?.Data?.CompanyID;
          if (marketerId) {
            await getMarketerById({ Data: { MarketerId: marketerId } });
          }
        }
        if (!result.Data) {
          dispatch(
            alertActions.error({
              message: result?.Message,
              header,
            }),
          );
          return;
        }
      } catch (error) {
        dispatch(
          alertActions.error({
            message: error.message ? ERR_MSG["073"] : error,
            header,
          }),
        );
      }
    };

    const handleInputChange = (value, row, columnKey) => {
        if (columnKey === "EffectiveDate" || columnKey === "EndDate") {
            const formattedValue = value?dayjs(value).format("YYYY-MM-DDTHH:mm:ss"): ''; // Format the date before sending it to handleChange
            
            handleChange(formattedValue, row, columnKey); // Call handleChange to update and validate
            // if(!formattedValue && columnKey ==='EffectiveDate') {
            //     setIsDataChanged(false);
            // } else {
            //     setIsDataChanged(true);
            // }
        }
    };

    
    const getMarketerById = async (marketerData) => {
        dispatch(alertActions.clear());
        if (marketerData) {
          try {
            const result = await dispatch(marketerAction.getById(marketerData)).unwrap();
            const formattedMarketerGroup = Array.isArray(result?.Data)
              ? result.Data.map(x => ({
                "Name": x.Name,
                  "AllocationGroupID": x.AllocationGroupID
              }))
              : [];
            
            setMarketerGroup(formattedMarketerGroup);
          } catch (error) {
            dispatch(
                alertActions.error({
                    message: error.message ? ERR_MSG["073"] : error,
                    header,
                })
            );
          }
        }
    };

    const handleChange = (newValue, rowData, field) => {
    
        let updatedRows = [...data];
    
        const rowIndex = updatedRows.findIndex(row => row.UserID === rowData.UserID);
        if (rowIndex !== -1) {
            updatedRows[rowIndex] = {
                ...updatedRows[rowIndex],
                [field]: newValue, // Save correctly formatted date
            };
          
          
        } else {
            updatedRows.push({ ...rowData, [field]: newValue });
        }
           if (field === "CompanyID" || field === "AllocationGroupID") {
            updatedRows[rowIndex].EffectiveDate = "";
            updatedRows[rowIndex].EndDate = "";
        }
        if (field === "CompanyID" )
       updatedRows[rowIndex].AllocationGroupID = "";
        setData(updatedRows); // Ensure re-rendering
        // setIsDataChanged(true);

        // if(field=="AllocationGroupID") {
        //     setIsDataChanged(true);
        // }

        if(updatedRows[rowIndex].AllocationGroupID && updatedRows[rowIndex].CompanyID && updatedRows[rowIndex].EffectiveDate && (updatedRows[rowIndex].EndDate ? updatedRows[rowIndex].EffectiveDate<=updatedRows[rowIndex].EndDate : true))
            setIsDataChanged(true);
        else setIsDataChanged(false);
    
        const marketer = {
            "Data": {
                "MarketerId": newValue,
            }
        }

        if(field=="CompanyID") {
            // setIsDataChanged(false);
            getMarketerById(marketer)
        }
    };

    const handleSave = async () => {
      dispatch(alertActions.clear());
      try {
        const transformedData = data.map((item) => ({
          CompanyAccountID: item.CompanyAccountID,
          AccountNumber: item.AccountNumber,
          CompanyID: item.CompanyID,
          CompanyName:
            marketerlist.find((x) => x.MarketerID === item.CompanyID)
              ?.MarketerName || null,
          AllocationGroupID: item.AllocationGroupID,
          AllocationGroup:
            marketerGroupList.find((y) => y.ID === item.AllocationGroupID)
              ?.GroupName || null,
          EffectiveDate: item.EffectiveDate
            ? dayjs(item.EffectiveDate).format("YYYY-MM-DDTHH:mm:ss")
            : null,
          EndDate: item.EndDate
            ? dayjs(item.EndDate).endOf("month").format("YYYY-MM-DDTHH:mm:ss")
            : null,
          AccountID: item.AccountID,
        }));

        if (transformedData) {
          const result = await dispatch(
            customerAction.updateCustomerDetails(transformedData[0]),
          ).unwrap();
          dispatch(alertActions.success({ message: result.Message, header }));

          const customerDetails = await dispatch(
            customerAction.getCustomerDetails(
              transformedData?.[0].AccountNumber,
            ),
          ).unwrap();
          if (customerDetails?.Data) {
            setData([customerDetails?.Data]);
            setActualData(customerDetails?.Data);
            setMarketerList(customerDetails?.Data?.Marketer);
            await getMarketerById({
              Data: {
                MarketerId: customerDetails?.Data?.CompanyID,
              },
            });
          }
        }
        setIsDataChanged(false);
      } catch (error) {
        dispatch(
          alertActions.error({
            message: error.message ? ERR_MSG["073"] : error,
            header: header,
          }),
        );
      }
    };

const handleCancelClick = () => {
    if (isDataChanged) {
        handleSearch(); // Only call API if data has changed
        setIsDataChanged(false);
    }
}
      const handleAddEdit = (row) => {
        row.toggleExpanded();
      };


    const columns = useMemo(() => ([
        {
            accessorKey: "AccountNumber",
            header: "Customer",
            Cell:({cell,row})=>(
                   <span onClick={() => handleAddEdit(row)}>
                    {cell.getValue()}
                   </span>
            )
        },
        {
            accessorKey: 'CompanyID',
            header: 'Marketer',
            Cell: ({ row, column }) => {
                const columnKey = column.id || column.accessorKey;
                return (
                    <DropdownTableInput
                        value={row.original[columnKey]}
                        label={`Select ${column.columnDef.header}`}
                        onChange={(value) => handleChange(value, row.original, columnKey)}
                        options={marketer}
                        disabled={!hasUpdateAccountMarketerAssociationAccess}
                    />
                );
            }
        },
        {
            accessorKey: 'AllocationGroupID',
            header: 'Group',
            Cell: ({ row, column }) => {
                const columnKey = column.id || column.accessorKey;
                return (
                    <DropdownTableInput
                        value={row.original[columnKey]}
                        label={`Select ${column.columnDef.header}`}
                        onChange={(value) => handleChange(value, row.original, columnKey)}
                        options={marketerGroups}
                        disabled={!hasUpdateAccountMarketerAssociationAccess}
                    />
                );
            }
        },
        {
            accessorKey: 'EffectiveDate',
            header: 'Association Start',
            filterFn: (row, columnId, filterValue) => {
                const dateValue = row.getValue(columnId);
                return dayjs(dateValue).format('MM-YYYY').toLowerCase().includes(filterValue.toLowerCase());
            },
            Cell: ({ cell, row }) => {
                const dateValue = cell.getValue();
                const effectiveDate = dayjs(actualData.EffectiveDate);
                const currentMonth = dayjs().startOf("month");
                const maxDate = dayjs().add(3, "month").endOf("month");
                const minDate = effectiveDate.isValid() && effectiveDate.isAfter(currentMonth)
  ? effectiveDate.add(1, "month").startOf("month")
  : currentMonth;

            
                return (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            className='SelectedDate'
                            views={['year', 'month']}
                            value={dayjs(dateValue)}
                            openTo='month'
                            onChange={(newValue) => {
                                const formattedValue = newValue ? newValue.format("YYYY-MM") : "";
                                handleInputChange(formattedValue, row.original, "EffectiveDate");
                            }}
                            minDate={minDate}
                            maxDate={maxDate}
                            slotProps={{
                                textField: (params) => <TextField {...params} />
                            }}
                            disabled={!hasUpdateAccountMarketerAssociationAccess}
                        />
                    </LocalizationProvider>
                );
            },
        },
        {
            accessorKey: 'EndDate',
            header: 'Association End',
            filterFn: (row, columnId, filterValue) => {
                const dateValue = row.getValue(columnId);
                return dayjs(dateValue).format('MM-YYYY').toLowerCase().includes(filterValue.toLowerCase());
            },
            Cell: ({ cell, row }) => {
                const dateValue = cell.getValue();
                const effectiveDate = row.original.EffectiveDate ? dayjs(row.original.EffectiveDate) : null;
                const minDate = effectiveDate || dayjs().startOf("month");
                const maxDate = dayjs().add(3, "month").endOf("month"); // Allow up to 4 months from current month
    
                return (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            className='SelectedDate'
                            views={['year','month']}
                            openTo='month'
                            value={dateValue ? dayjs(dateValue):null}
                            defaultCalendarMonth={dayjs()} 
                            disableOpenPicker={false}
                            onChange={(newValue) => {
                                const formattedValue = newValue ? newValue.format("YYYY-MM") : "";
                                handleInputChange(formattedValue, row.original, "EndDate");
                            }}
                            minDate={minDate}
                            maxDate={maxDate}
                            slotProps={{
                                textField: (params) => <TextField {...params} />
                            }}
                            disabled= {!hasUpdateAccountMarketerAssociationAccess}
                        />
                    </LocalizationProvider>
                );
            },
        },
    ]), [data, marketerlist,marketerGroup]);

      const table = useMaterialReactTable({
        columns,
        data,
        enableHiding: false,
        columnFilterDisplayMode: 'popover',
        enableFullScreenToggle: false,
        enableColumnActions: false,
        paginationDisplayMode: 'pages',
        enableExpandAll: false,
        positionToolbarAlertBanner: 'none',
        enableMultiSort: false,
        enablePagination:false,
        enableGlobalFilter: false,
        enableDensityToggle: false,
 // Ensure unique IDs for rows
        displayColumnDefOptions: {
          'mrt-row-expand': {
            header: "",
            size: 10, // make the expand column wider
            muiTableHeadCellProps: {
              sx: {
                display: 'none', // Hide the expand column
              },
            },
            muiTableBodyCellProps: {
              sx: {
                display: 'none', // Hide the expand column
              },
            },
            
          },
        },
        initialState: {
            columnOrder: [
                'AccountNumber',
                'CompanyID',
                "AllocationGroupID",
                "BillingCycleDay",
                'EffectiveDate',
                'EndDate'
            ]
        },
        muiTableBodyProps:{
            sx: { display: data.length > 0 ? "table-row-group" : "none" }, // Hide table body when empty
        },
        renderDetailPanel: ({ row }) => (
          <Box sx={{ padding: 2 }}>
            <CustomerDetails customerInfo={data}/>
          </Box>
        ),
        muiExpandButtonProps: {
          sx: {
            display: 'none',
          },
        },
      });
    return(
        <Box className="Customermanagement">
              <Typography component="div" className='userprofilelist'>
                <Grid container direction="row" spacing={2} >
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}  >
                        <Grid container  >
                            <Grid size={{ xs: 12, sm: 12, md: 12 }}  >
                                <Typography variant="h2" className='userprofilelistcontent'> Customer Management </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 8 }} className="PortalName" >
                        <Grid container spacing={2} className="justifyContent">
                            <Grid size={{ xs: 6, sm: 6, md: 6 }}  >
                                {/* <CustomerFilter isOpen={openComponent === 'filter'}
                                    onClose={handleCloseBackdrop}
                                    onOpen={() => handleOpenComponent('filter')} /> */}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TextField
        type="text"
        variant="outlined"
        fullWidth
        className="SearchIconinput"
        placeholder='Enter Account Number'
        margin="normal"
        value={searchInput}
        // onChange={(e) => setSearchInput(e.target.value)} // Update state on input change
        onChange={(e) => {
            const value = e.target.value;
            // Only allow digits and limit to 12 characters
            if (/^\d{0,12}$/.test(value)) {
              setSearchInput(value);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && /^\d{12}$/.test(searchInput)) {
              handleSearch();
            }
          }}
          error={searchInput.length > 0 && searchInput.length !== 12}
          helperText={
            searchInput.length > 0 && searchInput.length !== 12
                ? <div>Invalid account number.</div>
                : <></>
            }
        InputProps={{
            maxLength: 10, // Ensures no more than 10 digits
            pattern: "\\d{10}",
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className="SearchIcon" 
            //   onClick={handleSearch}
              onClick={searchInput.length === 12 ? handleSearch : undefined}
              style={{ cursor: searchInput.length === 12 ? 'pointer' : 'not-allowed', opacity: searchInput.length === 12 ? 1 : 0.5 }}
              />
            </InputAdornment>
          ),
          'aria-label': 'search FAQs'
        }}
      />
            <Box className="Customertable">
                <MaterialReactTable
                    table={table}
                />
                </Box>
            </LocalizationProvider>
            <Grid container>
            <Grid size={{ xs: 12, sm: 12, md: 12 }} className="Personal-Information">
            <Button variant="contained" color="red" className="cancelbutton" onClick={handleCancelClick}>
              Cancel
            </Button>
            <Button type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className='submitbutton'
              onClick={handleSave}
              disabled={!isDataChanged || !hasUpdateAccountMarketerAssociationAccess} 
            > 
              Save
            </Button>
          </Grid>
            </Grid>
        </Box>
    )
}

export default Customer;